import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input, Signal } from '@angular/core';
import { ElementErrorDirective } from '@components/element-widgets/element-error/element-error.directive';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomEvents } from '@utils/events/custom-events';
import { EventContext } from '@utils/events/event-context';
import { FondDetailsContentComponent } from './fond-details-content/fond-details-content.component';

@Component({
  selector: 'wct-fond-details',
  standalone: true,
  imports: [
    TranslocoModule,
    FondDetailsContentComponent,
    ElementErrorDirective,
  ],
  templateUrl: './fond-details.component.html',
  styleUrls: ['./fond-details.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FondDetailsComponent {
  @Input({ required: true }) public name!: Signal<string>;
  @Input({ required: true }) public redirectUrl!: string;
  @Input({ required: true }) public selectedFund!: string;
  @Input({ required: true }) public hideBackButton: Signal<boolean>;

  private readonly eventContext = inject(EventContext, { optional: true });

  protected back(): void {
    this.eventContext?.dispatch(CustomEvents.Back, null);
  }
}
